import { ReduxState } from "main/javascripts/reducers/";

export const getLocale: (state: ReduxState) => string = (
  state: ReduxState
): string => state.localeReducer.locale;
